import { gate } from 'hub-http/gates';
import identity from 'transmute/identity';
import { fetchLeadPipelineSettingsRest, fetchLeadPipelineSettings } from '../../input/leads/leadPipelineSettingsApi';
import { InMemoryCache } from '../InMemoryCache';
export const makeLeadPipelineSettingsCache = () => new InMemoryCache('LeadPipelineSettingsCache', identity, ({
  httpClient,
  rpcClient,
  getIsUngated
}) => key => getIsUngated(gate('CRM:Properties:LeadSettingsChirp')) ? fetchLeadPipelineSettings(rpcClient) : fetchLeadPipelineSettingsRest(key, httpClient));